import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FinishedProductModel } from '../../../../@models/erp/finishedProduct';
import { EPriceType, PriceItem, PriceMatrixModel } from '../../../../@models/erp/priceMatrix';

@Component({
  selector: 'ngx-unit-converter',
  templateUrl: './unit-converter.component.html',
  styleUrls: ['./unit-converter.component.scss']
})
export class UnitConverterComponent implements OnChanges {

  @Input() finishedProduct: FinishedProductModel;
  @Input() price: PriceItem;
  @Output() priceChange = new EventEmitter<PriceItem>();

  name = '2nd-unit-calc';
  secondUnit = 1;

  rollLength: number;
  rollWidth: number;
  areaWeight: number;

  pricePc: number;
  priceM2: number;
  priceM: number;
  priceM100: number;
  priceKg: number;

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    this.init();
  }

  init() {
    if (!this.finishedProduct || !this.price) return;
    this.rollLength = this.finishedProduct.content.energy.rollLength; 
    this.rollWidth = this.finishedProduct.content.energy.width;
    this.areaWeight = this.finishedProduct.product?.weight;


    const fromUnit = this.secondUnit = +this.price.type

    this.pricePc = this.convert(+this.price.value, 1, fromUnit);
    this.priceM = this.convert(+this.price.value, 2, fromUnit);
    this.priceM100 = this.convert(+this.price.value, 3, fromUnit);
    this.priceM2 = this.convert(+this.price.value, 4, fromUnit);
    this.priceKg = this.convert(+this.price.value, 5, fromUnit);

    console.log('unit-converter', +this.price.value, fromUnit, EPriceType.PricePerKg, this.priceKg)

  }

  convert(value, fromUnit, toUnit) {
    let pc = 0;
    switch (fromUnit) {
      case 1: pc = value; break; // pieces
      case 2: pc = value  / this.rollLength; break; // linearmeters
      case 3: pc = 100 * value / this.rollLength; break; // 100 linearmeters
      case 4: pc = 1000 * value / (this.rollWidth * this.rollLength); break; // squaremeters
      case 5: pc = 1000000 * value / (this.rollWidth * this.rollLength * this.areaWeight); break; // kilogram
    }
    switch (toUnit) {
      case 1: return pc;
      case 2: return pc * this.rollLength;
      case 3: return pc * this.rollLength * 0.01;
      case 4: return pc * this.rollLength * this.rollWidth / 1000;
      case 5: return pc * this.rollLength * this.rollWidth * this.areaWeight / 1000000;
    }
  }

  onUnitChange(type, value) {
    this.price.type = type;
    this.price.value = +(value.toFixed(4));
    this.priceChange.emit(this.price);
  }

}
